<template>
  <v-container>
    <v-row dense>
      <v-col
        cols="12"
        class="text-h6"
        v-html="$t('exhibitionArea.dinnerExcursionSightseeing')"
      />
      <v-col cols="12">
        <v-btn color="primary" :href="registerUrl" target="_new" class="ml-2">
          <v-icon left>mdi-wallet</v-icon>
          {{ $t("exhibitionArea.bookThroughRegistration") }}
        </v-btn>
      </v-col>
      <v-col cols="12">
        <v-divider />
      </v-col>
      <v-col
        cols="12"
        class="my-n2 text-h6"
        v-html="$t('exhibitionArea.hotelReservation')"
      />
      <v-col cols="12">
        <iframe
          width="355"
          height="480"
          :src="hotelReservationUrl"
          frameborder="0"
          scrolling="no"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { API_BASE } from "../config/constants";

export default {
  computed: {
    ...mapGetters(["pageSettings", "currentExhibitor"]),
    registerUrl() {
      return `${this.pageSettings.registerPageUrl}?booth=${this.currentExhibitor.title}#/registration`;
    },
    hotelReservationUrl() {
      return `${API_BASE}/iframe/${
        this.$i18n.locale === "de" ? "qf-scgeo-de.html" : "qf-scgeo-en.html"
      }`;
    },
  },
};
</script>
